export default __webpack_public_path__ + "static/media/program.dc471ba6.svg";